module.exports = __webpack_public_path__ + "img/btn.475f20cf.png";